import { MODULE_DESTINATION_IDS, type ModuleDestinationId } from "@/navigation";

import type { NavBarLinkPresentation } from "../types/navbar";

/** Active-route patterns, link kind, and count badge label for each side nav module. */
export const NAVBAR_LINK_PRESENTATION: Record<ModuleDestinationId, NavBarLinkPresentation> = {
  [MODULE_DESTINATION_IDS.profile]: {
    activePaths: ["/clients/*"],
    excludePaths: ["/clients/:clientId/edu-resources/*"],
    type: "anchor",
  },
  [MODULE_DESTINATION_IDS.clients]: {
    activePaths: ["/clients/*", "/practices/:organizationId/clients/*"],
    type: "anchor",
  },
  [MODULE_DESTINATION_IDS.schedule]: {
    activePaths: ["/practices/:organizationId/scheduling/*"],
    type: "button",
  },
  [MODULE_DESTINATION_IDS.admin]: { activePaths: ["/admin/project/*"], type: "anchor" },
  [MODULE_DESTINATION_IDS.practiceBilling]: {
    activePaths: ["/practices/:organizationId/billing"],
    type: "button",
  },
  [MODULE_DESTINATION_IDS.messages]: {
    activePaths: ["/practices/:organizationId/messages/*", "/messages/*"],
    badgeAriaLabel: "Unread messages count",
    type: "button",
  },
  [MODULE_DESTINATION_IDS.resources]: {
    activePaths: [
      "/practices/:organizationId/edu-resources/*",
      "/clients/:clientId/edu-resources/*",
    ],
    type: "button",
  },
  [MODULE_DESTINATION_IDS.tests]: {
    activePaths: ["/practices/:organizationId/tests/*"],
    badgeAriaLabel: "Lab orders count",
    type: "button",
  },
  [MODULE_DESTINATION_IDS.settings]: {
    activePaths: ["/practices/:organizationId/settings/*"],
    type: "button",
  },
};
